import { LayoutConst } from "core";
import styled from "styled-components";

export const NestedDropdownWrapper = styled.div`
    width: 100%;
    position: relative;

    .dropdown-element-popup {
        transform-origin: top;
        left: calc(100% - 10px);
        transform: translate(10px, -100px);
        width: 400px;
        min-width: 400px;
        max-width: 400px;
    }

    @media screen and (max-width: ${LayoutConst.screen.l}px) and (min-width: 920px) {
        .dropdown-element-popup {
            width: 300px;
            min-width: 300px;
            max-width: 300px;
        }
    }

    svg {
        max-height: 16px;
        max-width: 16px;
        flex-shrink: 0;
    }

    > div {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        .dropdown-element-popup {
            top: -46px;
            left: 20px !important;
            transform: translateX(10px);
        }
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {
        .dropdown-element-popup {
            width: 224px;
            min-width: 224px;
            max-width: 224px;
            left: calc(100vw - 244px);
        }
    }
`;

export const NestedDropdownTarget = styled.span`
    width: 100%;
    line-height: 18px;
    margin: 0;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
        margin-left: 15px;
    }
`;
import { LayoutConst } from "core";
import styled from "styled-components";

export const NestedDropdownWrapper = styled.div`
    width: 100%;
    position: relative;

    .dropdown-element-popup {
        transform-origin: top;
        left: calc(100% - 10px);
        transform: translate(10px, -100px);
        width: 400px;
        min-width: 400px;
        max-width: 400px;
    }

    @media screen and (max-width: ${LayoutConst.screen.l}px) and (min-width: 920px) {
        .dropdown-element-popup {
            width: 300px;
            min-width: 300px;
            max-width: 300px;
        }
    }

    svg {
        max-height: 16px;
        max-width: 16px;
        flex-shrink: 0;
    }

    > div {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        .dropdown-element-popup {
            top: -46px;
            left: 20px !important;
            transform: translateX(10px);
        }
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {
        .dropdown-element-popup {
            width: 224px;
            min-width: 224px;
            max-width: 224px;
            left: calc(100vw - 244px);
        }
    }
`;

export const NestedDropdownTarget = styled.span`
    width: 100%;
    line-height: 18px;
    margin: 0;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
        margin-left: 15px;
    }
`;
